import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import * as S from './styles';
import { DashboardDeviceHeader } from './header';
import { alarm_device_icon_states } from 'console/device/icon/transform';
import { useDashboard } from '../../../provider';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { useDashboardControl } from '../../../provider/control';
import { isPropsEqual } from 'console/shared/utils/memo';
import { AnimatePresence } from 'framer-motion';
import { useInView, useMounted } from 'shared/hooks/utils';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { DashboardHeatingDevice } from './tabs/heating';
import { DashboardGraphs } from './tabs/graphs';
import { DashboardVehicleDevice } from './tabs/vehicle';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { useSkeleton } from 'console/shared/features/skeleton/hook';
import { Box } from '@mui/material';
const tabs = {
    [DefaultTabKey.heat_tab]: DashboardHeatingDevice,
    [DefaultTabKey.vehicle_tab]: DashboardVehicleDevice,
    [DefaultTabKey.graphs]: DashboardGraphs,
};
export const DashboardDeviceView = memo(function Z3KDashboardDevice() {
    const { device_id, is_vehicle_device } = useDeviceConfig();
    const is_mounted = useMounted();
    const { icon_state } = useDeviceState();
    const { setDevicesRfs, sorting_mode } = useDashboard();
    const { is_devices_wrapped } = useDashboardControl();
    const [in_view, device_ref] = useInView();
    const is_alarm = useMemo(() => alarm_device_icon_states.includes(icon_state), [icon_state]);
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const tab_key = useMemo(() => dashboard_settings?.devices?.find(({ id }) => device_id === id)?.tab ??
        DefaultTabKey.heat_tab, [dashboard_settings?.devices]);
    useEffect(() => {
        if (is_mounted.current && device_ref != null) {
            setDevicesRfs((rfs) => ({ ...rfs, [device_id]: device_ref }));
        }
        return () => {
            if (is_mounted.current) {
                setDevicesRfs((rfs) => Object.fromEntries(Object.entries(rfs).filter(([id]) => device_id === Number(id))));
            }
        };
    }, [is_alarm]);
    const Component = useMemo(() => tabs[tab_key], [tab_key]);
    const Skeleton = useSkeleton(is_vehicle_device ? DefaultTabKey.vehicle_tab : DefaultTabKey.heat_tab, in_view);
    return (_jsxs(S.Device, { ref: device_ref, children: [_jsx(S.DeviceHeader, { className: "dashboard-device-header", device_state: icon_state, children: _jsx(DashboardDeviceHeader, { dashboard_sorting_mode: sorting_mode, tab_key: tab_key, device_id: device_id, is_alarm: is_alarm }) }), _jsx(AnimatePresence, { exitBeforeEnter: true, initial: false, children: !is_devices_wrapped && (_jsx(Skeleton, { children: _jsx(Box, { width: "100%", height: "100%", overflow: "auto", children: Component && _jsx(Component, {}) }) })) })] }));
}, isPropsEqual);
